<nav class="pager" aria-label="Result pages">
    <span class="range" data-testid="page-range">{{ rangeText }}</span>
    <button
        type="button"
        class="page-btn nav"
        [disabled]="safePage === 1"
        (click)="GoTo(safePage - 1)"
        aria-label="Previous page">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="15 5 8 12 15 19"></polyline>
        </svg>
    </button>

    <ng-container *ngFor="let token of pageTokens; trackBy: TrackByToken">
        <button
            *ngIf="IsNumber(token); else gap"
            type="button"
            class="page-btn"
            [class.active]="token === safePage"
            [attr.aria-current]="token === safePage ? 'page' : null"
            (click)="GoTo(token)">
            {{ token }}
        </button>
        <ng-template #gap><span class="gap" aria-hidden="true">…</span></ng-template>
    </ng-container>

    <button
        type="button"
        class="page-btn nav"
        [disabled]="safePage === totalPages"
        (click)="GoTo(safePage + 1)"
        aria-label="Next page">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="9 5 16 12 9 19"></polyline>
        </svg>
    </button>

    <label class="size-select">
        <span class="size-label">Per page</span>
        <select (change)="OnSizeSelect($event)" [value]="pageSize" aria-label="Results per page">
            <option *ngFor="let opt of pageSizeOptions" [value]="opt" [selected]="opt === pageSize">
                {{ opt }}
            </option>
        </select>
    </label>
</nav>
